<template>
    <div class="query_results">
        <Navbar :bgColor="'#fff'">
            <div class="title" slot="title">
                <span>{{ $route.query.startCity }}</span>
                <img src="@assets/right_arrow.png" />
                <span>{{ $route.query.endCity }}</span>
            </div>
        </Navbar>
        <!-- 日期列表 -->
        <div class="calendar-list">
            <div class="calendar-date" ref="scrollLeft">
                <div
                    :class="['list-item', selectDate == index ? 'active' : '']"
                    v-for="(item, index) in calendarList"
                    :key="index"
                    @click="handleDate(index)"
                    ref="scroll"
                >
                    <span class="week">{{ item.week }}</span>
                    <span class="date">{{ item.date }}</span>
                </div>
            </div>
            <div class="calendar-btn" @click="isCalendar = true">
                <img class="calendar" src="@assets/calendar.png" alt="" />
                <img class="down-icon" src="@assets/down_icon.png" alt="" />
            </div>
        </div>
        <!-- 车次列表 -->
        <div class="train-number-list" v-if="transportation == 1">
            <div class="filter-container">
                <van-checkbox v-model="onlyGD" @change="onlyGDSelected">只看高铁/动车</van-checkbox>
                <van-checkbox
                    style="margin-left: 2rem"
                    v-model="onlyHaveTickets"
                    @change="onlyHaveTicketsSelected"
                >
                    只看有票
                </van-checkbox>
            </div>
            <template v-if="train.length">
                <train-number-item
                    v-for="item in trainList"
                    :key="item"
                    :data="item"
                    @handleClick="submitOrder"
                ></train-number-item>
            </template>
            <no-data v-else :icon="require('@assets/no_search.png')" :title="noDataTitle"></no-data>
        </div>
        <!-- 飞机列表 -->
        <div class="train-number-list" v-if="transportation == 2">
            <template v-if="air.length">
                <aircraf-number-item
                    v-for="item in air"
                    :key="item"
                    :data="item"
                    @handleClick="submitOrder"
                ></aircraf-number-item>
            </template>
            <no-data v-else :icon="require('@assets/no_search.png')" :title="noDataTitle"></no-data>
        </div>
        <!-- 日历 -->
        <van-calendar
            v-model="isCalendar"
            :default-date="defaultDate"
            color="#1989fa"
            :show-mark="false"
            :show-confirm="false"
            :min-date="minDate"
            :max-date="maxDate"
            @select="calendarConfirm"
            :style="{ width: contentWidth, left: contentLeft }"
            position="bottom"
        />
        <div class="unable-float-btn" :style="unableButtonStyle" @click="openUnableRemark">
            <span>无合适车</span>
            <span>人工协助</span>
        </div>
        <van-dialog
            v-model="showRemarkDialog"
            title="手动备注"
            show-cancel-button
            confirm-button-text="提交"
            :before-close="beforeCloseUnableRemark"
        >
            <van-field
                class="unable-remark-field"
                v-model="unableRemark"
                type="textarea"
                rows="4"
                maxlength="200"
                show-word-limit
                autosize
            />
        </van-dialog>
    </div>
</template>

<script>
import Navbar from '@components/Common/Navbar'
import TrainNumberItem from './components/TrainNumberItem.vue'
import AircrafNumberItem from './components/AircrafNumberItem.vue'
import utils from '@utils/index.js'
import { mapState, mapGetters } from 'vuex'
import noData from '@components/Common/NoData.vue'
export default {
  components: {
    Navbar,
    TrainNumberItem,
    AircrafNumberItem,
    noData
  },
  data () {
    return {
      title: '',
      selectDate: 0,
      isCalendar: false,
      transportation: 1,
      date: '',
      week: '',
      defaultDate: '',
      calendarList: [],
      train: [],
      air: [],
      minDate: '',
      maxDate: '',
      onlyGD: false,
      onlyHaveTickets: false,
      showRemarkDialog: false,
      unableRemark: '',
      noDataTitle: '当前线路暂无直达方案'
    }
  },
  computed: {
    ...mapState('user', ['guestId']),
    ...mapGetters(['contentWidth', 'contentLeft']),
    unableButtonStyle () {
      if (this.contentWidth == '100%') return {}
      return {
        right: `calc((100% - ${this.contentWidth}) / 2 + 0.8rem)`
      }
    },
    trainList () {
      // 如果没有任何过滤条件，直接返回全部数据
      if (!this.onlyGD && !this.onlyHaveTickets) return this.train;

      return this.train.filter(item => {
        // 条件1：是否只看高铁/动车（如果未勾选，则默认通过）
        const isMatchGD = !this.onlyGD || /G|D/.test(item.trainNo);

        // 条件2：是否只看有票（如果未勾选，则默认通过）
        // 使用 some() 替代 forEach 累加，只要有一个座位 num > 0 即为有票
        const isMatchTickets = !this.onlyHaveTickets || item.seatList.some(seat => seat.num > 0);

        // 且逻辑：两个条件必须同时满足
        return isMatchGD && isMatchTickets;
      });
    }
  },
  created () {
    // Vant Calendar 需要 Date 对象；通过 utils.parseDate 兼容 iOS Safari 日期字符串解析。
    this.minDate = utils.parseDate(sessionStorage.getItem('minDate'))
    this.maxDate = utils.parseDate(sessionStorage.getItem('maxDate'))
  },
  mounted () {
    console.log('sadfs', sessionStorage.getItem('minDate'), sessionStorage.getItem('maxDate'))
    utils
      .getMiddleData(
        'day',
        sessionStorage.getItem('minDate'),
        sessionStorage.getItem('maxDate')
      )
      .map(item => {
        this.calendarList.push({
          date: `${item.split('-')[1]}/${item.split('-')[2]}`,
          defaultDate: utils.parseDate(item),
          week: this.getWeek(item),
          originDate: item
        })
      })
    const { transportation } = this.$route.query
    this.transportation = transportation
    // 站内跳转优先沿用已选日期；没有缓存时，深链使用 URL 携带的日期初始化。
    let date = sessionStorage.getItem('currentDate')
    if (!date) {
      date = this.$route.query.date
      if (date) sessionStorage.setItem('currentDate', date)
    }
    const index = this.checkDay(date)
    this.selectDate = index
    this.defaultDate = this.calendarList[index || 0].defaultDate

    // 选中日期滑动到可视区
    this.scrollLeft()
    this.getData(date)
  },
  methods: {
    onlyGDSelected () { },
    onlyHaveTicketsSelected () { },
    getTripTypeText () {
      if (String(this.$route.query.type) == '1') return '来程'
      if (String(this.$route.query.type) == '2') return '返程'
      return ''
    },
    getTransportationText () {
      if (String(this.$route.query.transportation) == '1') return '火车'
      if (String(this.$route.query.transportation) == '2') return '飞机'
      return '车'
    },
    openUnableRemark () {
      const date = utils.dealFormData(
        this.defaultDate || sessionStorage.getItem('currentDate'),
        'Y-m-d'
      )
      const start = this.$route.query.start || this.$route.query.startCity || ''
      const end = this.$route.query.end || this.$route.query.endCity || ''
      this.unableRemark = `${this.getTripTypeText()}无合适${this.getTransportationText()}：${start} 至 ${end}，出行日期 ${date}，请协助人工处理。`
      this.showRemarkDialog = true
    },
    beforeCloseUnableRemark (action, done) {
      if (action !== 'confirm') {
        done()
        return
      }
      this.submitUnableRemark(done)
    },
    submitUnableRemark (done) {
      const content = (this.unableRemark || '').trim()
      const guestId = this.guestId || localStorage.getItem('guestId')
      if (!content) {
        this.$toast('请输入备注内容')
        done(false)
        return
      }
      if (content.length > 200) {
        this.$toast('备注最多输入200字')
        done(false)
        return
      }
      if (!guestId) {
        this.$toast('嘉宾信息缺失，请重新进入')
        done(false)
        return
      }

      this.$showLoading()
      this.$Req('common/addGuestFeedback', {
        guestId,
        content
      })
        .then(() => {
          this.$toast('已记录，请联系会务人员处理')
          this.$hideLoading()
          done()
        })
        .catch(() => {
          this.$hideLoading()
          done(false)
        })
    },
    // 火车票查询日期是否已超过未来15天(预售期外)
    isOutOfBookingWindow (date) {
      const target = new Date(utils.parseDate(date))
      target.setHours(0, 0, 0, 0)
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      const sellEndDate = new Date(today)
      sellEndDate.setDate(today.getDate() + 14)
      return target > sellEndDate
    },
    // 获取“当天(今天)的后一天”的日期
    getDayAfterToday () {
      const date = new Date()
      date.setDate(date.getDate() + 1)
      return date
    },
    getData (date) {
      this.$showLoading()
      const {
        transportation,
        start,
        startCity,
        end,
        endCity,
        type,
        endStationCode,
        startStationCode
      } = this.$route.query
      let url = transportation == 1 ? 'common/getTrain' : 'common/getAirplane'
      // 火车票若查询日期已超过未来15天(预售期外)，接口暂无法返回该日期的车次数据，
      // 此时改用“当天(今天)的后一天”的日期查询，并把该车次可订坐席数量统一置为99
      const outOfBookingWindow = transportation == 1 && this.isOutOfBookingWindow(date)
      const requestDate = outOfBookingWindow ? this.getDayAfterToday() : date
      let params = {
        startStation: transportation == 1 ? start : startCity,
        endStation: transportation == 1 ? end : endCity,
        dateTime: utils.dealFormData(requestDate, 'Y-m-d'),
        type: type,
        endStationCode: endStationCode,
        startStationCode: startStationCode,
        guestId: this.guestId
      }
      this.$Req(url, params, { customConfig: { ignore: false } })
        .then(res => {
          console.log(res, '查询列表')
          this.$hideLoading()
          this.getNoDataTitle(utils.dealFormData(date, 'Y-m-d'))
          if (transportation == 1) {
            // 预售期外的兜底查询：按接口返回的该车次自带坐席数据生成 seatList（不写死席别），
            // 可订席位(canOrder==1)数量统一置为99(票量充足)，并打 isDemoSeat 标记，
            // 仅此场景下数量99的坐席才显示“预订”
            this.train = outOfBookingWindow
              ? (res || []).map(item => ({
                ...item,
                seatList: (item.seatList || []).map(seat =>
                  seat.canOrder == 1
                    ? { ...seat, num: '99', isDemoSeat: true }
                    : seat
                )
              }))
              : res
          } else this.air = res
        })
        .catch(err => {
          this.getNoDataTitle(utils.dealFormData(date, 'Y-m-d'))
          if (transportation == 1) this.train = []
          else this.air = []
          this.$hideLoading()
          console.log(err)
        })
    },
    getNoDataTitle (date) {
      const targetDate = new Date(date.replace(/-/g, '/'));
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const maxDate = new Date(today);
      maxDate.setDate(today.getDate() + 14);


      // 4. 分别判断两种情况
      if (targetDate < today) {
        this.noDataTitle = '您选择的日期已过，请选择今天或未来的出行日期'
        return;
      }

      if (this.transportation == 1) {

        if (targetDate > maxDate) {
          this.noDataTitle = '该日期车次暂未开放查询（提前15天开售）'
          return;
        }
      }
      this.noDataTitle = '当前线路暂无直达方案'
    },
    // 日期列表选中
    handleDate (index) {
      this.selectDate = index
      this.defaultDate = this.calendarList[index].defaultDate
      // 缓存标准日期字符串，避免 Date 对象转字符串后在 iOS Safari 解析失败。
      sessionStorage.setItem('currentDate', utils.dealFormData(this.defaultDate, 'Y-m-d'))
      this.getData(this.defaultDate)
    },
    // 获取周
    getWeek (date) {
      let weeks = ['日', '一', '二', '三', '四', '五', '六']
      let day = utils.parseDate(date || new Date()).getDay()
      return `周${weeks[day]}`
    },
    // 获取日期
    getDay (date) {
      return date.getMonth() + 1 + '月' + date.getDate() + '日'
    },
    // 日历组件去确认
    calendarConfirm (date) {
      this.isCalendar = false
      this.date = this.getDay(date)
      this.selectDate = this.checkDay(date)
      this.scrollLeft()
      this.getData(date)
      // 缓存标准日期字符串，避免 Date 对象转字符串后在 iOS Safari 解析失败。
      sessionStorage.setItem('currentDate', utils.dealFormData(date, 'Y-m-d'))
    },
    // 判断同一天日期
    checkDay (date) {
      let acctiveIndex = 0
      this.calendarList.map((item, index) => {
        if (
          utils.parseDate(item.originDate).setHours(0, 0, 0, 0) ==
          utils.parseDate(date).setHours(0, 0, 0, 0)
        ) {
          return (acctiveIndex = index)
        }
      })
      return acctiveIndex
    },
    // 日历滑动
    scrollLeft () {
      let _this = this
      _this.$nextTick(() => {
        const left = document.querySelector('.active').getBoundingClientRect().left - 5
        _this.$refs.scrollLeft.scrollBy({
          left: left, // 每次点击滚动的距离
          behavior: 'smooth'
        })
      })
    },
    submitOrder (data) {
      this.$router.push({
        path: '/details',
        query: {
          week: this.calendarList[this.selectDate].week,
          transportation: this.transportation,
          endCity: this.$route.query.endCity,
          startCity: this.$route.query.startCity,
          startStation: data.startStation,
          endStation: data.endStation,
          startTime: data.startTime,
          endTime: data.endTime,
          trainNo: data.trainNo,
          craft: data.craft,
          flightNo: data.flightNo,
          endTerminal: data.endTerminal,
          punctualRate: data.punctualRate,
          startTerminal: data.startTerminal,
          costTime: data.costTime,
          day: data.day,
          costTime: data.costTime,
          flightNo: data.flightNo,
          airline: data.airline,
          craft: data.craft,
          food: data.food,
          type: this.$route.query.type,
          ticketId: this.$route.query.ticketId,
          ticketStatus: this.$route.query.ticketStatus,
          bookingMethod: 1
        }
      })
      sessionStorage.removeItem('seatList')
      sessionStorage.setItem('seatList', JSON.stringify(data.seatList))
    }
  }
}
</script>

<style lang="scss" scoped>
.query_results {
    display: flex;
    flex-direction: column;

    .title {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;

        > span {
            font-size: 0.66rem;
        }

        > img {
            margin: 0 0.16rem;
            width: 0.66rem;
            height: 0.66rem;
        }
    }

    .calendar-list {
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;
        height: 2.79rem;
        padding: 0 0.21rem;
        background: #fff;

        .calendar-date {
            display: flex;
            width: 100%;
            height: 2.79rem;
            padding-right: 3rem;
            overflow-y: hidden;
            overflow-x: auto;

            .list-item {
                cursor: pointer;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;
                width: 1.97rem;
                height: 2.79rem;

                > .week {
                    font-size: 0.57rem;
                    color: #162b40;
                }

                > .date {
                    margin-top: 0.1rem;
                    font-size: 0.49rem;
                    color: rgba(22, 43, 64, 0.45);
                }
            }

            .active {
                background: linear-gradient(180deg, #bedcff 0%, #f3f5f7 100%);
                border-radius: 0.33rem 0.33rem 0rem 0rem;

                > .week {
                    font-size: 0.57rem;
                    font-weight: 500;
                    color: #0072f5;
                }

                > .date {
                    margin-top: 0.1rem;
                    font-size: 0.49rem;
                    color: #0072f5;
                }
            }
        }

        .calendar-btn {
            position: absolute;
            top: 0;
            right: 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 3rem;
            height: 2.79rem;
            padding-left: 0.5rem;
            z-index: 10;
            background: url('~@assets/left_mark.png') no-repeat center/cover;
            background-position-x: 0;
            background-position-y: 0;
            background-size: 0.62rem 100%;
            background-color: #fff;

            > .calendar {
                width: 0.98rem;
                height: 0.98rem;
            }

            > .down-icon {
                width: 0.66rem;
                height: 0.66rem;
            }
        }
    }

    .train-number-list {
        flex: 1;
        padding-bottom: 0.25rem;
        overflow: auto;

        ::v-deep {
            > span {
                color: rgba(22, 43, 64, 0.65) !important;
            }
        }
    }
}

.filter-container {
    margin-top: 0.4rem;
    margin-left: 0.5rem;
    display: flex;
}

.unable-float-btn {
    position: fixed;
    right: 0.8rem;
    top: 50%;
    z-index: 100;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 3.6rem;
    height: 2.38rem;
    padding: 0 0.49rem;
    transform: translateY(-50%);
    border-radius: 1.19rem;
    background: #0072f5;
    box-shadow: 0 0.16rem 0.49rem rgba(0, 114, 245, 0.25);
    color: #fff;
    font-size: 0.49rem;
    font-weight: 500;
    text-align: center;
    line-height: 0.66rem;
    cursor: pointer;
    white-space: nowrap;
}

::v-deep .unable-remark-field {
    margin: 0.49rem 0.66rem 0.66rem;
    width: auto;
    border: 0.02rem solid #dcdee0;
    border-radius: 0.26rem;
    padding: 0.41rem;
}
</style>
